module.exports = __webpack_public_path__ + "img/circle_icon.428fdd68.png";